const dialogResourceReducer = (state = {}, action) => {
    switch (action.type) {
        case 'RESET_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                create: null,
                isLoading: false,
                error: false,
                errorMessage: null,
            });
        case 'GET_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: true,
                error: false,
                errorMessage: null,
                resource: action.data.resource
            });
        case 'DONE_GET_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                data: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_GET_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'GET_DIALOG_RESOURCE_DETAILS':
            return Object.assign({}, state, {
                detailsData: null,
                isLoadingDetails: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_GET_DIALOG_RESOURCE_DETAILS':
            return Object.assign({}, state, {
                detailsData: action.data,
                isLoadingDetails: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_GET_DIALOG_RESOURCE_DETAILS':
            return Object.assign({}, state, {
                detailsData: null,
                isLoadingDetails: false,
                error: true,
                errorMessage: action.data
            });
        case 'CREATE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                create: null,
                resource: action.data.resource,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_CREATE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                create: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_CREATE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                create: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'UPDATE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                update: null,
                resource: action.data.resource,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_UPDATE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                update: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_UPDATE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                update: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'DELETE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: null,
                isLoading: true,
                resource: action.data.resource,
                error: false,
                errorMessage: null
            });
        case 'DONE_DELETE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_DELETE_DIALOG_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'UPLOAD_DIALOG_DOCUMENT':
            return Object.assign({}, state, {
                create: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_UPLOAD_DIALOG_DOCUMENT':
            return Object.assign({}, state, {
                create: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_UPLOAD_DIALOG_DOCUMENT':
            return Object.assign({}, state, {
                create: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESET_DIALOG_RESOURCE_MESSAGE':
            return Object.assign({}, state, {
                deleteResource: null,
                update: null,
                create: null,
                error: false,
                errorMessage: null
            });
        case 'CLEAR_DIALOG_INFO_RESOURCE':
            return Object.assign({}, state, {
                data: null,
            });
        default:
            return state;
    }
};

export default dialogResourceReducer;